<template>
  <div>
    <a-form class="simiot-nested-search-form" :form="form" @submit="handleSearch">
      <a-row :gutter="24">
        <a-col :span="5">
          <a-form-item label="套餐名称">
            <a-input
              v-decorator="['name', {
                normalize: this.$lodash.trim
              }]"
              allow-clear
            />
          </a-form-item>
        </a-col>

        <a-col :span="5">
          <a-form-item label="共享属性">
            <a-select
              v-decorator="['traffic_share_property']"
              allow-clear
            >
              <a-select-option
                v-for="option in trafficSharePropertyOptions"
                :key="option.value"
                :value="option.value"
              >
                {{ option.label }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :span="5">
          <a-form-item label="标签">
            <a-select
              v-decorator="['tag']"
              allow-clear
            >
              <a-select-option
                v-for="option in tagsOptions"
                :key="option.value"
                :value="option.value"
              >
                {{ option.label }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :span="4">
          <a-form-item>
            <a-space>
              <a-button type="primary" html-type="submit">
                搜索
              </a-button>
              <a-button @click="handleReset">
                刷新
              </a-button>
            </a-space>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>
<script>
import { findTrafficSharePropertyOptions, findProductTagOptions } from '@/api/common_options'

export default {
  name: 'ImportCarrierProductSearch',
  data() {
    return {
      expand: false,
      trafficSharePropertyOptions: findTrafficSharePropertyOptions(),
      tagsOptions: findProductTagOptions(),
      form: this.$form.createForm(this, { name: 'import_carrier_products_search' })
    }
  },
  methods: {
    handleSearch(e) {
      e.preventDefault()
      this.$emit('submit', this.form.getFieldsValue())
    },

    handleReset() {
      this.form.resetFields()
      this.$emit('submit', {})
    }
  }
}
</script>
